import React from "react";
import { Outlet } from "react-router-dom";
import {
  LayoutDashboard, Briefcase, Package, Image, Newspaper, Star, HelpCircle,
  Inbox, FileText, ShoppingBag, Receipt, FolderKanban, Users, LifeBuoy,
  MessageSquare, UserPlus, CreditCard, Settings as Cog, Mail, MailCheck, Wallet, Store,
} from "lucide-react";
import DashboardShell from "@/components/DashboardShell";
import { useI18n } from "@/lib/i18n";

export default function AdminLayout() {
  const { t, lang } = useI18n();
  const nav = [
    ["/admin", t("admin.dashboard"), LayoutDashboard, true],
    ["/admin/quotes", t("admin.quotes"), Inbox],
    ["/admin/offers", t("admin.offers"), FileText],
    ["/admin/withdrawals", lang === "de" ? "Widerrufe & Erstattungen" : "Withdrawals & refunds", Receipt],
    ["/admin/orders", t("admin.orders"), ShoppingBag],
    ["/admin/shop", t("admin.shop"), Store],
    ["/admin/invoices", t("admin.invoices"), Receipt],
    ["/admin/projects", t("admin.projects"), FolderKanban],
    ["/admin/customers", t("admin.customers"), Users],
    ["/admin/tickets", t("admin.tickets"), LifeBuoy],
    ["/admin/messages", t("admin.messages"), MessageSquare],
    ["/admin/leads", t("admin.leads"), UserPlus],
    ["/admin/services", t("admin.services"), Briefcase],
    ["/admin/packages", t("admin.packages"), Package],
    ["/admin/portfolio", t("admin.portfolio"), Image],
    ["/admin/blog", t("admin.blog"), Newspaper],
    ["/admin/testimonials", t("admin.testimonials"), Star],
    ["/admin/faqs", t("admin.faqs"), HelpCircle],
    ["/admin/payments", t("admin.payments"), CreditCard],
    ["/admin/payment-methods", t("admin.paymentMethods"), Wallet],
    ["/admin/email-config", t("admin.emailConfig"), Mail],
    ["/admin/email-templates", t("admin.emailTemplates"), MailCheck],
    ["/admin/settings", t("admin.settings"), Cog],
  ];
  return <DashboardShell nav={nav} home={t("nav.home")}><Outlet /></DashboardShell>;
}

